import './mutators/cardMutators';
import { createLazyComponent, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "ActionableMessage" */ './lazyIndex')
);

export const ActionableMessageCard = createLazyComponent(lazyModule, m => m.ActionableMessageCard);
export const lazyParseCardFromStringOrObject = new LazyImport(
    lazyModule,
    m => m.parseCardFromStringOrObject
);

export {
    CardOamAppNameMap,
    getCardTypeFromCardDetails,
    getCardOamAppProvider,
} from './utils/getCardType';
export { ComponentClass } from 'react';
export { MailboxInfo } from 'owa-client-ids';
export { default as parseCard } from './utils/parseCard';
export { default as Theme } from './store/schema/Theme';
export { default as TelemetryProvider } from './store/schema/TelemetryProvider';
export { default as TelemetryDetails } from './store/schema/TelemetryDetails';
export { default as ElementDetails } from './store/schema/ElementDetails';
export { default as CardLoadPerfCheckpoints } from './store/schema/CardLoadPerfCheckpoints';
export { default as MessageContext } from './store/schema/MessageContext';
export { default as ExecuteActionResponse } from './store/schema/ExecuteActionResponse';
export { default as ActionableMessageContentHandler } from './store/schema/ActionableMessageContentHandler';
export { default as CardDetails } from './store/schema/CardDetails';
export { default as ActionProvider } from './store/schema/ActionProvider';
export { ActionableMessageCardProps } from './components/ActionableMessageCard';
